import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/ui';

// The two apps a visitor can actually get. The admin console is ours, not
// theirs, so the public site does not list it.
const APPS = [
    { id: 'client', icon: '🧭' },
    { id: 'company', icon: '🏢' },
] as const;

export const Apps: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Section
            id="apps"
            tint
            eyebrow={t('web.apps.eyebrow')}
            title={t('web.apps.title')}
            sub={t('web.apps.sub')}
        >
            <div className="grid grid--2">
                {APPS.map((app) => (
                    <article className="tile" key={app.id}>
                        <div className="tile__icon" aria-hidden="true">{app.icon}</div>
                        <h3 className="tile__title">{t(`web.apps.${app.id}.name`)}</h3>
                        <p className="tile__body">{t(`web.apps.${app.id}.body`)}</p>
                        <div className="tile__meta">{t(`web.apps.${app.id}.who`)}</div>
                    </article>
                ))}
            </div>
        </Section>
    );
};
